<template>
    <div id="login">
        <div class="loginStyle">
            <div class="loginRight">
                <!-- <div class="flexs" style="padding-bottom:24px;align-items: center;justify-content: center;">   
                    <img src="../assets/img/u120.png" style="width:182px;"/>
                    <p style="color:#b2b7bc;font-size:54px;font-weight:600;">&nbsp;&nbsp;&nbsp;&nbsp;CRM&nbsp;</p>
                </div> -->
                <!--  密码登录   -->
                <el-steps :active="active" simple>
                    <el-step title="账户密码" icon="el-icon-edit"></el-step>
                    <el-step title="登录平台" icon="el-icon-upload"></el-step>
                </el-steps>
                <div v-if='active == 1'>
                    <el-form :model="PsdLoginType" ref="PsdLoginType" :rules="rules" size="medium" style="width:80%; margin:12px auto 0;" class="iptStyle">
                        <el-form-item prop="accountName">
                            <el-input  v-model="PsdLoginType.accountName" maxlength="50"  placeholder="请输入用户名" >
                                <img src="../assets/img/YH.svg" slot="prefix" alt="用户名" style="width:14px;height:14px;padding:11px 0px 0px 3px;">
                            </el-input>
                        </el-form-item >
                        <el-form-item prop="password">
                            <el-input show-password v-model="PsdLoginType.password" maxlength="40" placeholder="请输入密码" clearable>
                                <img src="../assets/img/MM.svg" slot="prefix" alt="密码" style="width:14px;height:14px;padding:11px 0px 0px 3px;">
                            </el-input>
                        </el-form-item>
                        <el-form-item class=" re" prop="verifyCode">
                            <el-input v-model="PsdLoginType.verifyCode" placeholder="请输入验证码" :maxlength='4' clearable style="width:190px;">
                                <img src="../assets/img/YZM.svg" slot="prefix" alt="验证码" style="width:14px;height:14px;padding:11px 0px 0px 3px;">
                            </el-input>
                            <span @click="getCode()" style="display:inline-block;height:34px;border:1px solid #cdcdcd;border-radius:3px;overflow:hidden;left:202px;" class="ab cursors" >
                                <img :src="codeSrc" alt="" >
                            </span>
                        </el-form-item>
                        <el-form-item style="margin-top:26px;">
                            <el-button  type="primary" v-if="!isClick" @click.native.prevent="codeLogin('PsdLoginType')"  @keyup.enter.native="codeLogin('PsdLoginType')" style="font-size:14px;width:100%;">登&nbsp;&nbsp;&nbsp;录</el-button>
                            <el-button  type="info" v-if="isClick"  style="font-size:14px;width:100%;" disabled="disabled">登&nbsp;&nbsp;&nbsp;录</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="margin-top: 20px;" v-else>
                    <li v-for="item in platformList" :key="item.id" style="padding:12px;background: rgba(255,255,255,.2);margin: 3px 0px;" @click="goPlat(item)">进入 {{item.sysName}} 平台</li>
                </div>
            </div>
        </div>
        <div style="position:fixed;bottom: 20px;right:20px;font-size:14px;color:#f7f7f7;">愿君砥砺前行，赏尽两岸花开。</div>
    </div>
</template>
<script>    
 var axios = require('axios')
import { mapActions } from "vuex";
export default {
    name:'login',
    data() {
        return {
            isClick:false,
            codeSrc:"", //图形验证码路径
            rules:{
                accountName: [
                    { required: true, message: '请输入用户名', trigger: ["blur", "change"]},
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: ["blur", "change"]},
                ],
                verifyCode: [
                    { required: true, message: '请输入验证码', trigger: ["blur", "change"]},
                    { pattern: /^[a-zA-Z0-9]+$/, message: "由大小写字母，数字组成" },
                    { min: 4, message: "长度为4个字符",trigger: ["blur", "change"]}
                ]
            },
            // 密码登录
            PsdLoginType:{
                accountName:'',
                password:"",
                verifyCode:'',
                vtoken:""
            },
            title:'',
            nmb:120, // 短信验证码时间
            timer:null,
            active:1,
            platformList:[],
            token:""
        };
    },
    methods: {
        ...mapActions([
            'saveInfo','saveJumpParams'
        ]),
        //密码登录
        codeLogin(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loginSend();
                    this.isClick = true;
                } else {
                    return false;
                }
            });
        },
        //获取密码登录验证码
        getCode(){
            this.PsdLoginType.verifyCode = '';
            axios.defaults.withCredentials = true;
            axios({
                method: 'get',
                url: this.API.Sso + 'getVtoken',
            })
            .then(resd => {
                if(resd.data.code == 200){
                    this.PsdLoginType.vtoken = resd.data.data;
                    this.IsCode(resd.data.data);
                }else{
                   console.log('呵呵呵。。。报错了');
                }
            })
        },
        //判断密码登录验证码是否正确
        IsCode(vtoken){
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.Sso + 'getCode?vtoken=' + vtoken,
                transformRequest: [function (data) {
                    let ret = ''
                    for (let it in data) {
                        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
                    }
                    return ret
                }],
                responseType: "arraybuffer",
                headers:{'Content-Type':'application/x-www-form-urlencoded'}
            })
            .then(res => {
                this.codeSrc = 'data:image/jpeg;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            })
        },
        // 登录
        loginSend(){
            let obj = {};
            Object.assign(obj,this.PsdLoginType);
            obj.password = this.$md5(obj.password);
            axios.defaults.withCredentials = true;
            axios({
                method: 'post',
                url: this.API.Sso + 'admin/pwd/signIn',
                data: obj,
            })
            .then(resd => {
                if(resd.data.code == 200){
                    this.active = 2;
                    this.platformList = resd.data.data.systems;
                    this.token = resd.data.data.token;
                }else{
                    this.isClick = false;
                    this.getCode(); //重新获取验证码
                    this.$alert(resd.data.message, '温馨提示', { dangerouslyUseHTMLString: true,type: 'warning' });
                }
            })
        },
        // 选择平台(进入平台)
        goPlat(val){
            axios({
                method: 'get',
                url: this.API.Sso + `admin/without/skip/${val.sysCode}`,
                headers:{'Authorization': this.token}
            })
            .then(res => {
                if(res.data.code == 200){
                    if(res.data.data.sysCode == 'SYSTEM_1'){ 
                        //去往CRM平台
                        let param = {};
                        param.toSystemCode = res.data.data.sysCode;
                        param.accessToken = res.data.data.authToken;
                        // 获取用户基本信息
                        axios({
                            method: 'get',
                            url: this.API.Sso + 'admin/inner/skip/get/context',
                            params: param
                        }).then(res =>{
                            console.log(res.data.data)
                            document.cookie = "tibiot-crm="+ res.data.data.token +";path=/;"
                            let params = {};
                            let {staffCode, roles, leaderFirst} =  res.data.data;
                            Object.assign(params, {staffCode, roles, leaderFirst});
                            params.userName = res.data.data.staffName;
                            this.saveInfo(params);
                            let _ = this;
                            this.timer = setTimeout(()=>{
                                // 刷新页面
                                // location.reload();
                                _.$router.push('/home'); //跳转页面
                            },300);
                        })
                    }else{
                        // 去往国际卡平台
                        let { sysCode, authToken } = res.data.data;
                        window.open(res.data.data.jumpUrl + "?param=" + JSON.stringify({sysCode, authToken}), "_blank");  
                    }
                }else{
                   
                }
            })
        }
    },
    created(){
        
        // 清除token
        if(this.$common.getCookie('tibiot-crm')){
            document.cookie = 'tibiot-crm='+ this.$common.getCookie('tibiot-crm') +';path=/;expires=Thu,01 Jan 1970 00:00:00 GMT';
            window.localStorage.removeItem("vuex-along");//清除vue-along
        }
        // 拦截登录，跳转到联合登录页
        window.location.href = this.API.platformUrl;
        this.getCode(); //重新获取验证码
        // 注册回车事件
        document.onkeydown = e =>{
            if(window.event == undefined){
                var key = e.keyCode;
            }else{
                var key = window.event.keyCode;
            }
            if(key == 13){
                this.codeLogin('PsdLoginType');
            }
        }
    },
};
</script>
<style scoped>
    #login{
        width: 100%;
        height: 100%;
        background: url('../assets/img/N-L.jpg') rgba(0, 0, 0, .7) no-repeat; 
        background-size:100% 100%;
        background-blend-mode: multiply;
    }
    .loginStyle{
        position: absolute;
        left: 50%;
        top:200px;
        transform: translateX(-50%);
    }
    .loginleft{
        width: 400px;
        border-radius: 8px 0px 0px 8px;
        overflow: hidden;
    }
    .Left_top{
        height: 78px;
        line-height: 78px;
        font-size: 18px;
        color:#8E96A2;
    }
    .loginRight{
        padding:30px 30px 28px;
        width: 420px;
        background: #4749508a;
        border-radius: 10px;
    }
    .logo_img_ico{
        width:20px;
        height:20px;
        padding-top:1px;
    }
    
</style>
<style>
#login .el-tabs--card>.el-tabs__header .el-tabs__nav{
    border:0px;
}
#login .el-tabs__nav .el-tabs__item{
    height: 22px;
    line-height: 22px;
    background: #fff;
}
#login .el-tabs__item{
    font-size:16px;
    font-weight: 400;
}
#login .el-tabs__nav .is-active{
    background: #fff;
    font-size:17px;
}
#login .el-tabs__nav{
    float: none;
    text-align: center;
}
#login .el-tabs--card>.el-tabs__header{
    border-bottom:0px;
}
#login .el-tabs__header{
    margin:32px 0 10px;
}
#login .slide-verify-slider,#login .slide-verify{
    width:280px;
}
input:-webkit-autofill , textarea:-webkit-autofill, select:-webkit-autofill {  
        -webkit-text-fill-color: #ededed !important;  
        -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;  
        background-color:transparent;  
        background-image: none;  
        transition: background-color 50000s ease-in-out 0s; 
    } 
#login .el-steps--simple{
    background:rgba(0,0,0,0) ;
}
#login .el-step.is-simple .el-step__title{
    font-size: 20px;
    font-weight: 600;
}
#login .el-step__title.is-process,#login .el-step__head.is-process{
    color:#ccc;
}
#login .el-step.is-simple .el-step__arrow::after, #login .el-step.is-simple .el-step__arrow::before{
    height: 13px;
}
</style>


// WEBPACK FOOTER //
// src/login/login.vue